// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.upload-demo[data-v-24d4ae6f] {\r\n  display: inline-block;\n}\r\n", ""]);
// Exports
module.exports = exports;
